module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/brands_logo/aws-beb0e4b24e77972e1d8c273597789107.svg";